/**
 * True if due date is strictly before today's calendar date (local timezone).
 * @param {string|Date|null|undefined} dueDate - ISO date string or Date from API
 */
export function isInvoiceDueDatePast(dueDate) {
  if (dueDate == null || dueDate === '') return false;
  const dueStr =
    typeof dueDate === 'string'
      ? dueDate.slice(0, 10)
      : (() => {
          const d = new Date(dueDate);
          return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
        })();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dueStr)) return false;
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  return dueStr < todayStr;
}

/**
 * Status shown in the UI: unpaid sent/part-paid invoices past due_date display as overdue
 * (matches product rule; DB may still be `sent` until a write triggers status sync).
 */
export function getEffectiveInvoiceStatus({ status, dueDate }) {
  if (!status) return status;
  if (status === 'draft' || status === 'paid-in-full') return status;
  if (status === 'overdue') return 'overdue';
  if ((status === 'sent' || status === 'part-paid') && isInvoiceDueDatePast(dueDate)) {
    return 'overdue';
  }
  return status;
}
